import React from "react";
import styled from "@emotion/styled";
import {Tab, Tabs} from "@mui/material";

interface IStyledTabsProps {
	children?: React.ReactNode;
	value: string;
	variant: "standard" | "scrollable" | "fullWidth" | undefined;
	onChange?: (event: React.SyntheticEvent, newValue: string) => void;
}

export const StatsCentreTabs = styled((props: IStyledTabsProps) => (
	<Tabs {...props} TabIndicatorProps={{children: <span className="MuiTabs-indicatorSpan" />}} />
))({
	"& .MuiTabs-indicator": {
		width: "100%",
		backgroundColor: "#0FF",
	},
});

interface IStyledTabProps {
	label: string;
	value: string;
}

export const StatsCentreTab = styled((props: IStyledTabProps) => <Tab {...props} />)(({theme}) => ({
	color: "#E5E5EA",
	borderBottom: "none",
	fontFamily: theme.secondFont,
	fontSize: 16,
	"&.MuiButtonBase-root": {
		color: "#E5E5EA",
		fontWeight: 500,
		borderBottom: "3px solid #E5E5EA",
	},
	"&.MuiButtonBase-root.Mui-selected": {
		color: "#0FF",
		borderBottomColor: "#0FF",
	},
	"&.Mui-focusVisible": {
		backgroundColor: "rgba(100, 95, 228, 0.32)",
	},
}));

export const StatsCentreSubTabs = styled((props: IStyledTabsProps) => (
	<Tabs {...props} TabIndicatorProps={{children: <span className="MuiTabs-indicatorSpan" />}} />
))({
	background: "#545456",
	borderRadius: 168,
	"& .MuiTabs-indicator": {
		width: "100%",
		backgroundColor: "transparent",
	},
});

export const StatsCentreSubTab = styled((props: IStyledTabProps) => <Tab {...props} />)(
	({theme}) => ({
		color: "#E5E5EA",
		borderBottom: "none",
		fontFamily: theme.secondFont,
		fontSize: 14,
		"&.MuiButtonBase-root": {
			color: "#E5E5EA",
			fontWeight: 500,
			borderBottom: "none",
		},
		"&.MuiButtonBase-root.Mui-selected": {
			color: "#202020",
			background: "#0FF",
			border: "2px solid #545456",
			borderRadius: 132,
		},
	})
);
